import { styled, Tabs as MuiTabs, type TabsProps as MuiTabsProps } from '@mui/material';
import type { SyntheticEvent } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props<Value> = WithoutStyleOverrides<Omit<MuiTabsProps, 'value' | 'onChange' | 'slots' | 'slotProps'>> & {
  value: Value | false;
  onChange?: (event: SyntheticEvent, value: Value) => void;
  divider?: boolean;
};

const DividedTabs = styled(MuiTabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export function Tabs<Value>(props: Props<Value>) {
  const { divider, ...tabsProps } = props;

  if (divider) {
    return <DividedTabs {...tabsProps} />;
  }

  return <MuiTabs {...tabsProps} />;
}

export type { Props as TabsProps };
